import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Benefits } from "@/components/landing/Benefits";
import { Financials } from "@/components/landing/Financials";
import { Process } from "@/components/landing/Process";
import { Testimonials } from "@/components/landing/Testimonials";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";

const IMAGES = {
  hero: "https://images.unsplash.com/photo-1552053831-71594a27632d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGRvZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
  playroom: "https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHxfHxoYXBweSUyMGRvZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
  spa: "https://images.unsplash.com/photo-1782022491533-267c13b410bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxkb2clMjBncm9vbWluZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
  owner1: "https://images.unsplash.com/photo-1579119134757-5c38803f34fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzbWlsaW5nJTIwYnVzaW5lc3MlMjBvd25lciUyMHBvcnRyYWl0JTIwd2l0aCUyMGRvZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
  owner2: "https://images.unsplash.com/photo-1626913518213-21bedcbe32d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxzbWlsaW5nJTIwYnVzaW5lc3MlMjBvd25lciUyMHBvcnRyYWl0JTIwd2l0aCUyMGRvZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
  owner3: "https://images.unsplash.com/photo-1602900017944-678041f27dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwYnVzaW5lc3MlMjBvd25lciUyMHBvcnRyYWl0JTIwd2l0aCUyMGRvZ3xlbnwwfHx8fDE3OTM3NjY5OTd8MA&ixlib=rb-4.1.0&q=85",
};

export default function LandingPage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const navigate = (hash) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(hash, { offset: -80, duration: 1.4 });
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5]" data-testid="landing-page">
      <div className="grain-overlay" />
      <Nav onNavigate={navigate} />
      <main>
        <Hero onNavigate={navigate} image={IMAGES.hero} />
        <Marquee />
        <Benefits images={IMAGES} />
        <Financials />
        <Process />
        <Testimonials images={IMAGES} />
        <LeadForm image={IMAGES.spa} />
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}
